//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  Box,
  Button,
  Collapse,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  // Icon,
  Input,
  Stack,
  Text,
  useRadio,
  useRadioGroup,
} from "@chakra-ui/react";
import { Field, Formik } from "formik";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { object, string } from "yup";
import { RequestDataContext } from "../../request-flow/RequestDataProvider";
import { useFormSubmission } from "../../../utils/hooks";
import LocationSelector from "../../parent-flow/components/LocationSelector";
import { useGetRegionAndIpLocation } from "../components/LocationSelector/hook";
import Icon from "../../../components/ui-elements/Icon";
import { scrollToId } from "../../../utils/functions";
import { ILocationFieldStore } from "../../../stores";
import {
  AutocompleFormField,
  FullGetMapProps,
} from "../../../_new_/components/location-form-with-map/components";
import CTAButtons from "./CTAButtons";

const CustomRadio = (props) => {
  const { value, children, radio, firstItem, ...rest }: any = props;
  const { getInputProps, getCheckboxProps } = useRadio(radio);

  const input: any = getInputProps();
  const checkbox = getCheckboxProps();
  const { checked: isChecked, disabled: isDisabled } = input;

  return (
    <Box
      p={[3, 4]}
      as="label"
      opacity={isDisabled ? 0.6 : 1}
      cursor={!isDisabled ? "pointer" : "not-allowed"}
      borderWidth="2xs"
      borderColor={isChecked ? "blue.500" : "gray.200"}
      boxShadow={isChecked ? "0 0 0 1px #0054E5" : "none"}
      rounded="fbRadius"
      flex="1 1 auto"
      marginInlineStart={[
        "0 !important",
        !firstItem ? "1.25rem !important" : "",
      ]}
      _focus={{ outline: "none" }}
      _hover={{ borderColor: isChecked ? "blue.500" : "gray.300" }}
      {...rest}
      {...checkbox}
    >
      <input {...input} />
      <Stack isInline spacing={[3, 4]}>
        <Icon
          name="check-circle"
          color={isChecked ? "blue.500" : "gray.200"}
          size={5}
          mr={3}
        />
        <Box>{children}</Box>
      </Stack>
    </Box>
  );
};

const LessonTypeSelector = ({
  name,
  key,
  spacing,
  defaultValue,
  onChange,
  options,
}: any) => {
  const { getRootProps, getRadioProps } = useRadioGroup({
    name: name,
    defaultValue: defaultValue,
    onChange,
  });
  const group = getRootProps();
  return (
    <Stack
      {...group}
      isInline
      key={key}
      display="flex"
      flexDirection={["column", "row"]}
      spacing={spacing}
    >
      {options.map((option, index) => {
        const radio = getRadioProps({ value: option.value } as any);
        return (
          <CustomRadio
            key={option.value}
            radio={radio}
            option={option}
            firstItem={index === 0}
            mb={[index === 0 ? "1rem" : "0", "0"]}
          >
            <Stack>
              <Text fontSize="md" fontWeight="medium" lineHeight="none">
                {option.label}
              </Text>
              <Text fontSize="sm" opacity={0.8}>
                {option.description}
              </Text>
            </Stack>
          </CustomRadio>
        );
      })}
    </Stack>
  );
};

let initialValue = {
  lessonType: "physical",
  country: "",
  state: "",
  region: "",
  vicinity: "",
  address: "",
};

let validationSchema = object().shape({
  lessonType: string()
    .transform((value) => (Array.isArray(value) ? "" : value))
    .required("Lesson type is required"),
  country: string().required("Country is required"),
  state: string().required("State is required"),
  region: string().when("country", {
    is: "Nigeria",
    then: string().required("Region is required"),
    otherwise: string(),
  }),
  vicinity: string().when("lessonType", {
    is: "physical",
    then: string().required("Please enter nearest bus stop"),
    otherwise: string(),
  }),
  address: string().when("lessonType", {
    is: "physical",
    then: string().required("Please enter street address"),
    otherwise: string(),
  }),
});

let locationHolder = (country) => {
  const isForeign = country !== "Nigeria";
  const physical = {
    label: "Physical",
    description: "Home lessons",
    value: "physical",
  };
  const online = {
    label: "Online",
    description: "Virtual lessons",
    value: "online",
  };
  const options = isForeign ? [online] : [physical, online];

  return {
    lessonType: {
      label: "Lesson type",
      options,
    },
  };
};

let placeholders = {
  lessonType: {
    label: "Lesson type",
    options: [
      {
        label: "Physical",
        description: "Home lessons",
        value: "physical",
      },
      {
        label: "Online",
        description: "Virtual lessons",
        value: "online",
      },
    ],
  },
  country: {
    label: "Country",
    placeholder: "Select country",
  },
  state: {
    label: "State",
    placeholder: "Select state",
  },
  region: {
    label: "Region",
    placeholder: "Select region",
  },
  vicinity: {
    label: "Nearest bus stop to your home",
    placeholder: "Type nearest bus stop",
  },
  address: {
    label: "Street address",
    placeholder: "Enter street address",
  },
};

export const useLocationFormHook = ({
  onSubmit,
  toNextPage,
  fetchedCountries,
  fetchedIpLocations,
  fetchedRegions,
  sessionID,
  subjectDetails,
}) => {
  let {
    onUpdateContactDetails,
    requestData: { contactDetails: value },
  }: any = useContext(RequestDataContext);
  function _onSubmitForm(data) {
    let result = onUpdateContactDetails(data, subjectDetails);
    return result;
  }
  let [loading, onSubmitForm] = useFormSubmission(
    onSubmit,
    toNextPage,
    _onSubmitForm,
    sessionID
  );
  let _ip_location = fetchedIpLocations;
  if (sessionID) {
    if (value && value.state) {
      _ip_location = value;
    }
  } else {
    value = initialValue;
    ["state", "region", "country"].forEach((field) => {
      if (fetchedIpLocations && fetchedIpLocations[field]) {
        _ip_location[field] = fetchedIpLocations[field];
        value[field] = fetchedIpLocations[field];
      }
    });
  }

  const [regions, ip_location, countries, showCountry] =
    useGetRegionAndIpLocation({
      value,
      fetchedRegions,
      fetchedIpLocations: _ip_location,
      fetchedCountries,
    });

  let locationFetchingProps = {
    valueProp: ip_location,
    regions,
    countries,
  };
  return {
    loading,
    onSubmitForm,
    locationFetchingProps,
    showCountry,
    value: ip_location,
  };
};

const commonProps = ({ name }, { touched, errors }) => ({
  ...placeholders[name],
  isInvalid: Boolean(touched[name] && errors[name]),
  errorMessage: errors[name],
});

export const LocationForm: React.FC<{
  locationSelectorVM: ILocationFieldStore;
  defaultCountry?: string;
  geocoder?: FullGetMapProps;
  getCountryCode?: (country: string) => string;
  nextStep?: string;
  [key: string]: any;
}> = observer(
  ({
    nextStep = "Last step: Contact",
    formInitialValues = {},
    onSubmitForm,
    locationSelectorProps = {},
    loading = false,
    defaultCountry,
    spacing = "20px",
    locationSelectorVM,
    onBack,
    geocoder, // {updateStateAndVicinity, location, setLocation}
    getCountryCode = (country: string) => null,
  }) => {
    const [showFormError, setShowFormError] = React.useState(false);

    const onSubmitClick = (errors = {}) => {
      if (errors) {
        if (Object.values(errors).length) {
          setShowFormError(true);
          scrollToId("form-header-section");
        } else {
          setShowFormError(false);
        }
      }
    };
    return (
      <Formik
        key={`${locationSelectorVM.country} ${locationSelectorVM.regions.length} ${locationSelectorVM.stateOptions.length} ${defaultCountry}`}
        validationSchema={validationSchema}
        initialValues={formInitialValues}
        onSubmit={(data) => onSubmitForm(data)}
        render={({ handleSubmit, values, errors }) => {
          const countryCode = getCountryCode(values?.country) || "NG";
          return (
            <form
              onSubmit={(value) => {
                handleSubmit(value);
                onSubmitClick(errors);
              }}
            >
              <Stack spacing={spacing}>
                <Field name="lessonType">
                  {({ field, form }) => (
                    <FormControl isInvalid={commonProps(field, form).isInvalid}>
                      <FormLabel>{placeholders.lessonType.label}</FormLabel>
                      <LessonTypeSelector
                        name="lessonType"
                        key={locationSelectorVM.lessonType}
                        defaultValue={
                          locationSelectorVM.clientLessonType || "physical"
                        }
                        spacing={[3, spacing]}
                        options={
                          locationHolder(values.country).lessonType.options
                        }
                        onChange={(value) => {
                          locationSelectorVM.handleChange("lessonType", value);
                          form.setFieldValue(field.name, value);
                        }}
                      />
                      <FormErrorMessage>
                        {commonProps(field, form).errorMessage}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field>
                  {({ form }) => {
                    return (
                      <LocationSelector
                        key={`${locationSelectorVM.country} ${
                          locationSelectorVM.regions.length
                        } ${
                          locationSelectorVM.stateOptions(
                            locationSelectorVM.country
                          ).length
                        }`}
                        initialValues={formInitialValues}
                        commonProps={commonProps}
                        spacing={spacing}
                        onChange={() => {
                          form.setFieldValue(
                            "country",
                            locationSelectorVM.country
                          );
                          form.setFieldValue("state", locationSelectorVM.state);
                          form.setFieldValue(
                            "region",
                            locationSelectorVM.region
                          );
                        }}
                        viewModel={locationSelectorVM}
                        {...locationSelectorProps}
                      />
                    );
                  }}
                </Field>
                {values.country === "Nigeria" && (
                  <Collapse in={values.lessonType === "physical"}>
                    <Flex direction={["column", "row"]}>
                      <Field name="vicinity">
                        {({ field, form }) => (
                          <FormControl
                            flex={1}
                            isInvalid={commonProps(field, form).isInvalid}
                          >
                            <FormLabel>
                              {commonProps(field, form).label}
                            </FormLabel>
                            <Input
                              size="lg"
                              fontSize="md"
                              {...field}
                              {...commonProps(field, form)}
                            />
                            <FormErrorMessage>
                              {commonProps(field, form).errorMessage}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>

                      <Box boxSize={spacing} />

                      <Field name="address">
                        {({ field, form }) => {
                          return geocoder ? (
                            <AutocompleFormField
                              isInvalid={commonProps(field, form).isInvalid}
                              name={"address"}
                              label={commonProps(field, form).label}
                              // helpText={helpText}
                              field={field}
                              onBlur={(e) => {
                                console.log("onBlur", e);
                              }}
                              errorMessage={
                                commonProps(field, form).errorMessage
                              }
                              onChange={(p: any) => {
                                const newLocations =
                                  geocoder.updateStateAndVicinity(p);
                                console.log("newLocations", newLocations);
                                let newR: any = {};
                                [
                                  "address",
                                  "latitude",
                                  "longitude",
                                  "vicinity",
                                  "state",
                                ].forEach((key) => {
                                  if (newLocations[key]) {
                                    newR[key] = newLocations[key];
                                  }
                                });
                                form.setFieldValue("address", newR.address);
                                form.setFieldValue("latitude", newR.latitude);
                                form.setFieldValue("longitude", newR.longitude);
                                newR.vicinity &&
                                  form.setFieldValue("vicinity", newR.vicinity);
                                console.log("newR", newR);
                              }}
                              countryCode={countryCode}
                            />
                          ) : (
                            <FormControl
                              flex={1}
                              isInvalid={commonProps(field, form).isInvalid}
                            >
                              <FormLabel>
                                {commonProps(field, form).label}
                              </FormLabel>
                              <Input
                                size="lg"
                                fontSize="md"
                                {...field}
                                {...commonProps(field, form)}
                              />
                              <FormErrorMessage>
                                {commonProps(field, form).errorMessage}
                              </FormErrorMessage>
                            </FormControl>
                          );
                        }}
                      </Field>
                    </Flex>
                  </Collapse>
                )}
                <CTAButtons
                  onBackClick={onBack}
                  submitText={nextStep}
                  loading={loading}
                />
              </Stack>
            </form>
          );
        }}
      />
    );
  }
);

LocationForm.defaultProps = {
  onSubmit: (data) => alert(JSON.stringify(data)),
};

export default LocationForm;
